var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-template-editor" },
    [
      !_vm.previewMode
        ? _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "left-buttons" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v(" < " + _vm._s(_vm.$t("message.goBack")))]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "", small: "" },
                    on: { click: _vm.handleUpdateTemplate },
                  },
                  [
                    _c("i", { staticClass: "fas fa-save" }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("message.update")) + "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right-buttons" },
              [
                _c("SupsisButton", { on: { click: _vm.handleMjmlModalOpen } }, [
                  _vm._v("MJML"),
                ]),
                _vm._v(" "),
                _c("SupsisButton", { on: { click: _vm.handleHtmlModalOpen } }, [
                  _vm._v("HTML " + _vm._s(_vm.$t("message.show"))),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { on: { click: _vm.handleModelModalOpen } },
                  [_vm._v("Model " + _vm._s(_vm.$t("message.show")))]
                ),
                _vm._v(" "),
                _c("TemplateSelector", {
                  on: { "template-select": _vm.handleTemplateSelect },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "editor", staticClass: "grape-wrapper" }),
      _vm._v(" "),
      !_vm.previewMode
        ? [
            _vm.mjmlModalOpen
              ? _c(
                  "Modal2",
                  {
                    attrs: { title: "MJML" },
                    on: {
                      cancel: function ($event) {
                        _vm.mjmlModalOpen = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.editor &&
                            _vm.stripMailPlaceholderSpans(_vm.editor.getHtml())
                        ) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.htmlModalOpen
              ? _c(
                  "Modal2",
                  {
                    attrs: { title: "HTML" },
                    on: {
                      cancel: function ($event) {
                        _vm.htmlModalOpen = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.getRawHtml()) + "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.modelModalOpen
              ? _c(
                  "Modal2",
                  {
                    attrs: { title: "Model" },
                    on: {
                      cancel: function ($event) {
                        _vm.modelModalOpen = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.editor &&
                            JSON.stringify(_vm.editor.getComponents())
                        ) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a-modal",
              {
                attrs: { title: "Şablon özelliği", footer: null, width: 380 },
                on: { cancel: _vm.cancelMailPlaceholderModal },
                model: {
                  value: _vm.mailPlaceholderModalOpen,
                  callback: function ($$v) {
                    _vm.mailPlaceholderModalOpen = $$v
                  },
                  expression: "mailPlaceholderModalOpen",
                },
              },
              [
                _c("a-input", {
                  ref: "mailPlaceholderInput",
                  attrs: { placeholder: "Alan adı" },
                  on: { pressEnter: _vm.confirmMailPlaceholderInsert },
                  model: {
                    value: _vm.mailPlaceholderInput,
                    callback: function ($$v) {
                      _vm.mailPlaceholderInput = $$v
                    },
                    expression: "mailPlaceholderInput",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mail-placeholder-modal-actions" },
                  [
                    _c(
                      "a-button",
                      { on: { click: _vm.cancelMailPlaceholderModal } },
                      [_vm._v("İptal")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmMailPlaceholderInsert },
                      },
                      [_vm._v("Ekle")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }